/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useState, useRef, useLayoutEffect, useContext } from "react";
import { Button, Paper, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";
import ModelEditContext from "components/model-selector/context";
import { useClickAway } from "hooks/useClickAway";
import LabelledField from "components/labelled-field";
import ModalDialog from "components/model-selector/display/modal-dialog";

const ModelSelectorDisplayPanel = () => {
    const { t } = useTranslation();

    const ctx = useContext(ModelEditContext);
    const onChange = ctx?.onChange;
    const onRemove = ctx?.onRemove;
    const model = ctx?.model;

    const theme = useTheme();
    const buttonStyle = { color: theme.palette.primary.main };

    const wrapperRef = useRef();
    const infoButtonRef = useRef();
    const [location, setLocation] = useState({ top: 0, left: 0 });
    const [info, setInfo] = useState(false);

    const openInfo = async () => {
        setInfo(true);
    };
    const closeInfo = async () => {
        setInfo(false);
    };
    useClickAway(wrapperRef, closeInfo);

    useLayoutEffect(() => {
        if (infoButtonRef?.current) {
            setLocation({
                left: (infoButtonRef?.current?.offsetLeft || 0) - 10,
                top: (infoButtonRef?.current?.offsetTop || 0) + 30,
            });
        }
    }, [infoButtonRef]);

    return (
        <Fragment>
            {model && model?.guid && (
                <div className='simplicity-image-editor'>
                    <div className='simplicity-image-editor-view'>
                        <div className='image-display'>
                            <div
                                style={{
                                    border: "1px solid red",
                                    backgroundColor: "#dfdfdf",
                                    minHeight: "260px",
                                    padding: "12px",
                                }}
                            >
                                <div>{model.title}</div>
                                <div>{model.type}</div>
                            </div>
                            <div className='image-actions'>
                                <div className='image-info'>
                                    <IconButton
                                        ref={infoButtonRef}
                                        style={buttonStyle}
                                        aria-label='info'
                                        component='span'
                                        onClick={openInfo}
                                    >
                                        <InfoOutlinedIcon />
                                    </IconButton>
                                </div>
                                <div className='image-action-change'>
                                    <Button onClick={onChange}>{t("commons.change")}</Button>
                                </div>
                                <div className='image-action-remove'>
                                    <Button onClick={onRemove}>{t("commons.remove")}</Button>
                                </div>
                            </div>
                            <div ref={wrapperRef}>
                                {info ? (
                                    <ModalDialog
                                        location={location}
                                        zIndex={30}
                                        aria-labelledby='modal-modal-title'
                                        aria-describedby='modal-modal-description'
                                    >
                                        <Paper elevation={3} className='image-info-box'>
                                            <LabelledField label='Model Type' variant='subtitle1'>
                                                <span className='info-text'>{model.type}</span>
                                            </LabelledField>
                                            <LabelledField label='Title' variant='subtitle1'>
                                                <span className='info-text'>{model.title}</span>
                                            </LabelledField>
                                            <LabelledField label='Description' variant='subtitle1'>
                                                <span className='info-text'>{model.description}</span>
                                            </LabelledField>
                                            <LabelledField label='Version' variant='subtitle1'>
                                                <span className='info-text'>{model.version}</span>
                                            </LabelledField>
                                        </Paper>
                                    </ModalDialog>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default ModelSelectorDisplayPanel;
